import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../../../internal/index.js';

// eslint-disable-next-line react/display-name
import { jsx as _jsx } from "react/jsx-runtime";
const IconComponent = /*#__PURE__*/React.forwardRef((props, ref) => {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsx("path", {
      d: "M7.602 3.085c.266 1.355-.396 2.626-1.48 2.84-1.084.212-2.179-.713-2.445-2.068s.396-2.626 1.48-2.839c1.084-.213 2.179.712 2.445 2.067Zm4.805.772c.267-1.354-.396-2.625-1.48-2.838C9.843.805 8.75 1.73 8.483 3.086c-.267 1.355.396 2.626 1.48 2.839 1.084.213 2.178-.713 2.444-2.068ZM3.14 8.214c.717-.414.85-1.525.298-2.482-.552-.956-1.581-1.396-2.299-.982C.422 5.164.29 6.276.84 7.232c.553.957 1.582 1.397 2.3.982Zm9.422-2.481c-.552.956-.418 2.067.3 2.482.717.414 1.746-.026 2.298-.982.553-.957.419-2.068-.299-2.482-.717-.415-1.747.025-2.299.982Zm-9.871 5.21 2.132-2.788c1.6-2.093 4.754-2.093 6.355 0l1.946 2.545a2.588 2.588 0 0 1-3.34 3.82l-.855-.489a2 2 0 0 0-1.886-.052l-1.303.651a2.455 2.455 0 0 1-3.049-3.687Z",
      fill: "currentColor"
    })
  }));
});

/**
 * Компонент иконки
 *
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.
 */
export const IconInfrastructurePet16 = createIcon(IconComponent);